import styled from "styled-components";

export const Contents = styled.div`
	padding: 0 1em;
`;
